import { NavBar } from '@hulu/react-style-components';
import styled, { css } from 'styled-components';

export const StyledNavBar = styled(NavBar)`
  z-index: 17;
  position: relative;
  font-family: InspireTWDC;

  .TrekNavBar-logoContainer {
    margin-right: 0;
  }

  .TrekNavBarItem-root {
    display: flex;
    justify-content: space-between;
    height: 60px;
  }

  .TrekNavBar-content {
    background: ${({ theme }): string => theme.admanColors!.blue.dark.bg1[0]};
    border-color: ${({ theme }): string => theme.admanColors!.blue.dark.bg1[0]};
    height: 60px;

    .TrekNavBar-appName {
      display: none;
    }

    .TrekNavBar-logoLink {
      margin-left: ${({ theme }): string => theme.spacers!.spacer04};
    }

    .TrekUserIdentifier-userName {
      font-family: InspireTWDC;
      color: ${({ theme }): string => theme.colors!.colorWhite2};
      overflow: hidden;
      line-height: 20px;
      text-transform: capitalize;
      letter-spacing: 0;
      max-width: 400px;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: inline-block;
    }
  }
`;

export const StyledLinkElement = styled.span<{ $disabled?: boolean; $isSelected?: boolean }>(
  ({ theme: { colors, spacers, admanColors }, $disabled, $isSelected }) => css`
    color: ${$disabled ? admanColors!.blue.light.fg[5] : admanColors!.blue.light.fg[4]};
    text-decoration: none;
    font-family: InspireTWDC;
    font-size: 16px;
    font-weight: ${$isSelected ? '600' : '400'};
    line-height: 21px;
    text-align: center;
    padding: ${spacers!.spacer02} ${spacers!.spacer03} ${spacers!.spacer02} ${spacers!.spacer04};
    gap: ${spacers!.spacer02} ${spacers!.spacer02};
    background-color: transparent;
    border: 1px solid transparent;
    cursor: ${$disabled ? 'not-allowed' : 'pointer'};
    text-transform: capitalize;
    user-select: none;

    @media only screen and (max-width: 920px) {
      padding: 0;
    }

    &:hover {
      color: ${colors!.colorWhite};
      font-weight: 500;
    }

    &:focus {
      color: ${colors!.colorWhite};
      font-weight: 600;
    }

    &:active {
      color: ${admanColors!.blue.light.fg[4]};
      font-weight: 600;
      border: 1px solid ${admanColors!.blue.light.fg[4]};
    }
  `
);

export const NavMenu = styled.div(
  ({ theme: { colors, spacers, admanColors } }) => css`
    display: flex;
    align-items: center;
    padding: 2px 0 0;
    gap: ${spacers!.spacer03};
    user-select: none;

    > a,
    > span,
    > div {
      &::before {
        content: attr(data-text);
        font-weight: 600;
        visibility: hidden;
        height: 0;
        display: block;
      }
    }

    > a,
    > div > a {
      color: ${admanColors!.blue.light.fg[4]};
      text-decoration: none;
      font-family: InspireTWDC;
      font-size: 16px;
      font-weight: 400;
      line-height: 21px;
      padding: ${spacers!.spacer02};
      gap: ${spacers!.spacer02};
      background-color: transparent;
      text-transform: capitalize;
      letter-spacing: 0;
      border: 1px solid transparent;
      position: relative;
      text-align: center;
      border-radius: 0;

      @media only screen and (max-width: 920px) {
        padding: 0;
      }

      &:hover {
        color: ${colors!.colorWhite};
        font-weight: 500;
      }

      &:focus {
        color: ${colors!.colorWhite5};
        font-weight: 600;
      }

      &:active {
        color: ${admanColors!.blue.light.fg[4]};
        border: 1px solid ${admanColors!.blue.light.fg[4]};
        font-weight: 500;
      }
    }
  `
);

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }): string => theme.spacers!.spacer05};
`;
